import { render, staticRenderFns } from "./xp-bar.vue?vue&type=template&id=e9026c5c&"
import script from "./xp-bar.vue?vue&type=script&lang=js&"
export * from "./xp-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports